import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import fixEncoding from '../utils/fixEncoding';
import '../styles/components/SearchBar.scss';
import searchIcon from '../assets/icons/search.svg';

const API_URL = process.env.REACT_APP_API_URL;

const SearchBar = () => {
  const navigate = useNavigate(); 
  const [query, setQuery]       = useState('');
  const [results, setResults]   = useState([]);
  const [images, setImages]     = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const searchBarRef = useRef(null);

  useEffect(() => {
    if (query.length < 2) {
      setResults([]);
      setShowResults(false);
      return;
    }

    const fetchResults = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/products/search`, {
          headers: { authorization: token },
          params: { query, limit: 8 },    
        });
        setResults(response.data);
        setShowResults(true);
      } catch (error) {
        console.error('Error fetching search results:', error);
      } finally {
        setIsLoading(false);
      }
    };

    const delay = setTimeout(fetchResults, 300);
    return () => clearTimeout(delay);
  }, [query]);

  useEffect(() => {
    if (results.length > 0) {
      const BASE_URL = process.env.REACT_APP_S3_BASE_URL;
      const newImages = {};
      results.forEach((product) => {
        if (product && Array.isArray(product.image_files) && product.image_files.length > 0) {
          newImages[product.reference] = `${BASE_URL}/thumbnails_mini/${product.image_files[0]}`;
        }
      });
      setImages(newImages);
    }
  }, [results]);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (searchBarRef.current && !searchBarRef.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const term = query.trim();
      if (term.length > 0) {
        navigate(`/productos/todos?search=${encodeURIComponent(term)}`);
        setShowResults(false);
      }
    }
  };

  return (
    <div className="search-bar" ref={searchBarRef}>
      <img src={searchIcon} alt="Buscar" className="search-bar__icon" />
      <input
        type="text"
        placeholder="Buscar productos..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown} 
      />
      {isLoading && <p className="search-bar__loading">Cargando…</p>}
      {showResults && results.length > 0 && (
        <div className="search-results">
          {results.map((product) => {
            const thumb = images[product.reference];
            return (
              <div key={product.id} className="search-result-item">
                {thumb ? (
                  <img
                    src={thumb}
                    alt={product.title}
                    className="search-result-item__img"
                  />
                ) : (
                  <div className="search-result-item__img--placeholder" />
                )}
                <a href={`/productos/${product.slug}`} className="search-result-item__link">
                  <span className="search-result-item__title">{fixEncoding(product.title)}</span>
                  {product.reference && (
                    <span className="search-result-item__ref">{product.reference}</span>
                  )}
                </a>
              </div>
            );
          })}
          <div className="search-result-advanced">
            <a href="/productos/todos">Búsqueda avanzada</a>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
